export { serializeSegmentationAnswers } from './serializeSegmentationAnswers';
